/**
 * @generated SignedSource<<9c738f88d2b94ad69bb6bf63af97b8b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationRoundControls_Booking$data = {
  readonly durationMins?: number | null | undefined;
  readonly id: string;
  readonly rounds: {
    readonly count: number;
  } | null | undefined;
  readonly " $fragmentType": "DurationRoundControls_Booking";
};
export type DurationRoundControls_Booking$key = {
  readonly " $data"?: DurationRoundControls_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationRoundControls_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationRoundControls_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationMins",
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "cbc40cd0e1ae4df3dfa3127351031a76";

export default node;
